.chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 12px;
  border-radius: var(--tuna-shape-radius-xl);
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-fontSize-sm);
  background-color: var(--tuna-palette-action-selected);
  color: var(--tuna-palette-text-primary);
  white-space: nowrap;
  cursor: default;
  user-select: none;
}

.clickable {
  cursor: pointer;
}

.clickable:hover {
  background-color: var(--tuna-palette-action-focus);
}

.chip:focus-visible,
.clickable:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.sizeSmall {
  height: 24px;
  font-size: var(--tuna-typography-fontSize-xs);
  padding: 0 8px;
}

.colorPrimary {
  background-color: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-contrastText);
}

.colorSecondary {
  background-color: var(--tuna-palette-secondary-main);
  color: var(--tuna-palette-secondary-contrastText);
}

.delete {
  display: inline-flex;
  cursor: pointer;
  margin: 0 -4px 0 4px;
  color: inherit;
  opacity: 0.7;
}

.delete:hover {
  opacity: 1;
}

.delete:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 1px;
  border-radius: var(--tuna-shape-radius-circle);
}

.outlined {
  background-color: transparent;
  border: 1px solid var(--tuna-palette-divider);
}

.colorSuccess {
  background-color: var(--tuna-palette-success-main);
  color: var(--tuna-palette-success-contrastText);
}

.outlined.colorPrimary {
  background-color: transparent;
  border-color: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-main);
}

.outlined.colorSuccess {
  background-color: transparent;
  border-color: var(--tuna-palette-success-main);
  color: var(--tuna-palette-success-main);
}

.colorError {
  background-color: var(--tuna-palette-error-main);
  color: var(--tuna-palette-error-contrastText);
}

.outlined.colorError {
  background-color: transparent;
  border-color: var(--tuna-palette-error-main);
  color: var(--tuna-palette-error-main);
}

.colorWarning {
  background-color: var(--tuna-palette-warning-main);
  color: var(--tuna-palette-warning-contrastText);
}

.colorInfo {
  background-color: var(--tuna-palette-info-main);
  color: var(--tuna-palette-info-contrastText);
}
